export const INTEGRATION_FUNCTIONALITY = {
	NDR: 'NDR',
};

export const VIEW_TYPE_GROUPS = {
  trip: ['retailTripsPrimary', 'retailTripsSecondary'],
  vehicle: ['tms_vehicle'],
} as const;

export const TRIP_VIEW_TYPES = VIEW_TYPE_GROUPS.trip;

type FieldConfig = {
  columnList: string;
  fullColumnList: string;
  filterList: string;
  currentFilterList: string;
  fullFilterList: string;
  filterMetadata: string;
  updatesList: string;
  activeUpdatesList: string;
};

const getFieldConfigByObjectType = (objectType: string | undefined): FieldConfig => {
  switch (objectType) {
    case 'trip':
      return {
        columnList: 'ops_trip_column_list',
        fullColumnList: 'ops_full_trip_column_list_by_bucket',
        filterList: 'ops_trip_filter_list',
        currentFilterList: 'ops_trip_current_filter_list_by_bucket',
        fullFilterList: 'ops_trip_full_filter_list_by_bucket',
        filterMetadata: 'ops_trip_filter_metadata',
        updatesList: 'ops_full_keys_list_by_bucket',
        activeUpdatesList: 'ops_keys_list_by_bucket',
      };

    case 'vehicle':
      return {
        columnList: 'tms_vehicle_column_list',
        fullColumnList: 'tms_full_vehicle_column_list_by_bucket',
        filterList: 'tms_vehicle_filter_list',
        currentFilterList: 'tms_vehicle_current_filter_list_by_bucket', 
        fullFilterList: 'tms_vehicle_full_filter_list_by_bucket',
        filterMetadata: 'tms_vehicle_filter_metadata', 
      };
    
    // backward compatibility (earlier only used for consignment view)
    default:
      return {
        columnList: 'ops_consignment_column_list',
        fullColumnList: 'ops_full_column_list_by_bucket',
        filterList: 'ops_filter_list_by_bucket',
        currentFilterList: 'ops_current_filter_list_by_bucket',
        fullFilterList: 'ops_full_filter_list_by_bucket',
        filterMetadata: 'ops_filter_metadata',
        updatesList: 'ops_full_keys_list_by_bucket',
        activeUpdatesList: 'ops_keys_list_by_bucket',
      };
  }
};

export const getViewFieldConfig = (viewType: string): FieldConfig => {
  // Find which group the viewType belongs to
  const objectType = Object.keys(VIEW_TYPE_GROUPS).find((key) =>
    (VIEW_TYPE_GROUPS as any)[key].includes(viewType)
  );

  return getFieldConfigByObjectType(objectType);
};
